import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getSpatialFromReducer = get('spatial.changeDeteced');

export const getIsLoading = state => fromReducer.getIsLoading(getSpatialFromReducer(state));

export const getCleanFields = state => fromReducer.getCleanFields(getSpatialFromReducer(state));
